import { PATH } from '@/constants/path';
import { IArticleSummary } from '@/types/cms';
import { getCanonicalOrigin } from '@/utils/jobListingHelper';
import { resolveUrl } from '@/utils/jsonLd';

const buildArticleUrl = (slug: string, origin: string): string =>
  resolveUrl(origin, `${PATH.ARTICLES}/${slug}`);

const dedupeBySlug = (articles: IArticleSummary[]): IArticleSummary[] => {
  const seenSlugs = new Set<string>();

  return articles.filter(article => {
    if (!article.slug || seenSlugs.has(article.slug)) {
      return false;
    }
    seenSlugs.add(article.slug);
    return true;
  });
};

/**
 * Builds a schema.org ItemList referencing the article card URLs shown on a Guides
 * listing page, per A2P-4351. Articles without a slug, and repeat appearances of the
 * same article (e.g. featured in both the "latest" section and a category section),
 * are skipped so every ListItem maps to one distinct card URL.
 */
export const buildArticleItemListJsonLd = (
  articles: IArticleSummary[],
  origin: string = getCanonicalOrigin(),
) => ({
  '@context': 'https://schema.org/',
  '@type': 'ItemList',
  itemListElement: dedupeBySlug(articles).map((article, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    url: buildArticleUrl(article.slug as string, origin),
  })),
});
